import { useState } from 'react';
import logo from '../../assets/logo.svg';

function traduzirErro(msg) {
  if (!msg) return 'Ocorreu um erro. Tente novamente.';
  const m = msg.toLowerCase();
  if (m.includes('invalid login credentials'))   return 'E-mail ou senha incorretos.';
  if (m.includes('email not confirmed'))         return 'E-mail ainda não confirmado. Verifique sua caixa de entrada.';
  if (m.includes('user already registered'))     return 'Este e-mail já está cadastrado. Tente entrar.';
  if (m.includes('password should be at least')) return 'A senha precisa ter pelo menos 6 caracteres.';
  if (m.includes('unable to validate email'))    return 'E-mail inválido. Verifique e tente novamente.';
  if (m.includes('signup is disabled'))          return 'Cadastros estão temporariamente desativados.';
  if (m.includes('email rate limit'))            return 'Muitas tentativas. Aguarde alguns minutos e tente novamente.';
  if (m.includes('failed to fetch') || m.includes('falha ao buscar') || m.includes('network') || m.includes('fetch')) return 'Sem conexão. Verifique sua internet e tente novamente.';
  return msg;
}

export default function AuthPage({ onLogin, onSignUp, onResetPassword }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage]   = useState('');
  const [isError, setIsError]   = useState(false);
  const [mode, setMode]         = useState('login'); // 'login' | 'forgot'
  const [loading, setLoading]   = useState(false);

  const handle = async (fn) => {
    if (!email || !password) {
      setMessage('Preencha email e senha');
      setIsError(true);
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      const error = await fn(email, password);
      if (error) {
        setMessage(traduzirErro(error.message));
        setIsError(true);
      } else {
        setIsError(false);
        if (fn === onSignUp) {
          if (window.fbq) window.fbq('track', 'CompleteRegistration');
          setMessage('Cadastro realizado! Verifique seu e-mail para confirmar a conta.');
        }
      }
    } catch (err) {
      setMessage('Ocorreu um erro. Tente novamente.');
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async () => {
    if (!email) {
      setMessage('Digite seu email primeiro');
      setIsError(true);
      return;
    }
    const error = await onResetPassword(email);
    if (error) {
      setMessage(error.message);
      setIsError(true);
    } else {
      setMessage('Email enviado! Verifique sua caixa de entrada. 📬');
      setIsError(false);
    }
  };

  if (mode === 'forgot') {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">🔑</div>
          <h1>Recuperar senha</h1>
          <p className="auth-subtitle">
            Digite seu email e enviaremos um link para criar uma nova senha.
          </p>

          <input
            type="email"
            placeholder="Seu email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="input"
            style={{ fontSize: '16px' }}
          />

          <button className="btn btn-primary" style={{ width: '100%' }} onClick={handleReset}>
            Enviar link de recuperação
          </button>

          <button
            className="btn btn-ghost"
            style={{ width: '100%' }}
            onClick={() => { setMode('login'); setMessage(''); }}
          >
            ← Voltar para o login
          </button>

          {message && (
            <p className={`msg ${isError ? 'msg-error' : 'msg-success'}`}>{message}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><img src={logo} alt="Clube do Eu" style={{ width: 160, height: 160 }} /></div>
        <p className="auth-subtitle">Seu espaço de escrita diária</p>

        <input
          type="email"
          placeholder="Seu email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="input"
          style={{ fontSize: '16px' }}
        />
        <input
          type="password"
          placeholder="Senha (mínimo 6 caracteres)"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="input"
          style={{ fontSize: '16px' }}
          onKeyDown={e => e.key === 'Enter' && handle(onLogin)}
        />

        <div className="auth-buttons">
          <button className="btn btn-primary" onClick={() => handle(onLogin)} disabled={loading}>
            {loading ? 'Aguarde...' : 'Entrar'}
          </button>
          <button className="btn btn-secondary" onClick={() => handle(onSignUp)} disabled={loading}>
            {loading ? 'Aguarde...' : 'Cadastrar'}
          </button>
        </div>

        <button
          className="btn btn-ghost"
          style={{ width: '100%', fontSize: '.875rem' }}
          onClick={() => { setMode('forgot'); setMessage(''); }}
        >
          Esqueci minha senha
        </button>

        {message && (
          <p className={`msg ${isError ? 'msg-error' : 'msg-success'}`}>{message}</p>
        )}
      </div>
    </div>
  );
}
